import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Label, Icon, Input } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { ReduxFormMaterialTextField, Button } from 'components';

import * as common from 'libs/commonFunc';

import styles from './TagItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class TagItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { tagItem, isEditMode, isTargetCount, currentTag, size, tagItemProp, tooltip } = this.props;

    const { tagNo, tagName, tagInitial, createUser, color, targetCount } = tagItem.toJS();
    let setColor = '#db2828';
    color === 'red' && (setColor = '#ff0000');
    color === 'orange' && (setColor = '#ff8a00');
    color === 'yellow' && (setColor = '#ffcc00');
    color === 'olive' && (setColor = '#c1d91f');
    color === 'lightgreen' && (setColor = '#76ea05');
    color === 'green' && (setColor = '#12bb52');
    color === 'pink' && (setColor = '#d90cec');
    color === 'purple' && (setColor = '#9c00ff');
    color === 'violet' && (setColor = '#632fda');
    color === 'blue' && (setColor = '#125be1');
    color === 'lightblue' && (setColor = '#0ea7e7');
    color === 'emerald' && (setColor = '#02dcc5');
    color === 'lightpink' && (setColor = '#ff6ce2');
    color === 'plum' && (setColor = '#ff1a86');
    color === 'darkplum' && (setColor = '#c90d6a');
    color === 'brown' && (setColor = '#a44200');
    color === 'ash' && (setColor = '#bb9b7c');
    color === 'apricot' && (setColor = '#ffb99a');
    color === 'grey' && (setColor = '#767676');
    color === 'black' && (setColor = '#1b1c1d');

    // 태그의 선택 유무
    let seleceted = '';
    if (typeof currentTag !== 'undefined' && currentTag.get('selectedTag').indexOf(tagNo) !== -1) {
      seleceted = 'seleceted';
    }

    let ContentComponent;
    let ButtonComponent;
    // 수정 모드
    if (isEditMode) {
      ContentComponent = (
        <div className={cx('input-wrapper')}>
          {/* 태그명 수정 */}
          {currentTag.get('isTagNameEdit') && currentTag.getIn(['isEditData', 'tagNo']) === tagNo ? (
            <div className={cx('input-tagName-wrapper')}>
              <ReduxFormMaterialTextField
                className={cx('input-tagName')}
                name="tagName"
                validate={['required', 'tagName']}
                autoFocus
                checkType={101}
                onKeyPress={e => {
                  tagItemProp.onKeypressTagName(e);
                }}
              />
            </div>
          ) : (
            <div className={cx('editMode-tagName')}>
              {tagName}
              <div className={cx('underline')} />
            </div>
          )}
        </div>
      );

      // 버튼 영역
      ButtonComponent = (
        <div className={cx('bt-area')}>
          {/* 태그명 수정 */}
          {currentTag.get('isTagNameEdit') && currentTag.getIn(['isEditData', 'tagNo']) === tagNo ? (
            <div className={cx('bt-area-inner')}>
              <Button
                className={cx('bt-icon')}
                icon
                title={defineMessages(formatMessage({ id: 'TagItem_1', defaultMessage: '저장' }))}
                size="tiny"
                onClick={e => {
                  e.stopPropagation();
                  tagItemProp.onSaveTagName();
                }}>
                <Icon name="checkmark" size="tiny" />
              </Button>
              <Button
                className={cx('bt-icon')}
                icon
                title={defineMessages(formatMessage({ id: 'TagItem_2', defaultMessage: '취소' }))}
                size="tiny"
                onClick={e => {
                  e.stopPropagation();
                  tagItemProp.onCancelTagName();
                }}>
                <Icon name="cancel" size="tiny" />
              </Button>
            </div>
          ) : (
            <div className={cx('bt-area-inner')}>
              <Button
                className={cx('bt-icon')}
                icon
                title={defineMessages(formatMessage({ id: 'TagItem_3', defaultMessage: '색상 수정' }))}
                size="tiny"
                onClick={e => {
                  e.stopPropagation();
                  tagItemProp.onEditTagColor(e, tagNo, tagName, color);
                }}>
                <Icon name="paint brush" size="tiny" />
              </Button>
              <Button
                className={cx('bt-icon')}
                icon
                title={defineMessages(formatMessage({ id: 'TagItem_4', defaultMessage: '태그 삭제' }))}
                size="tiny"
                onClick={e => {
                  e.stopPropagation();
                  tagItemProp.onToggleDeleteTag(tagNo, tagName, color);
                }}>
                <Icon name="trash" size="tiny" />
              </Button>
            </div>
          )}
        </div>
      );
      // 일반 뷰
    } else {
      // 태그의 대상자 수 및 툴팁 표시
      if (!!isTargetCount) {
        ContentComponent = (
          <div>
            {tagName}
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'TagItem_5', defaultMessage: '태그에 포함된 대상자 수' })) +
                ': ' +
                targetCount +
                defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))
              }
              placement="top">
              <div className={cx('tag-targetCount')}>
                <div className={cx('number')}>{!!isTargetCount && targetCount}</div>
              </div>
            </Tooltip>
          </div>
        );
      } else {
        ContentComponent = <div>{tagName}</div>;
      }
    }

    const tagContent = (
      <div
        className={cx(
          'TagItem-wrapper',
          { small: size === 'small' },
          { isEditMode: isEditMode },
          { selected: seleceted }
        )}>
        <div className={cx('editMode-area')}>
          <Label
            style={{ borderColor: setColor, backgroundColor: setColor }}
            onClick={
              // 해당 이벤트를 넘겨줄때만 클릭 처리
              !!tagItemProp
                ? e => {
                    tagItemProp.onClickEachTag(e, tagNo, tagName, color);
                  }
                : null
            }>
            <div className={cx('tag-name')} style={{ color: setColor }}>
              {/* 수정모드 */}
              {ContentComponent}
            </div>
            {ButtonComponent}
          </Label>
        </div>
      </div>
    );

    return tooltip ? (
      <Tooltip title={tagName} classes={{ tooltip: 'tooltip-noMaxWidth' }} placement="bottom">
        {tagContent}
      </Tooltip>
    ) : (
      tagContent
    );
  }
}

TagItem.propTypes = {
  tagItem: ImmutablePropTypes.mapContains({
    tagNo: PropTypes.number,
    tagName: PropTypes.string,
    createUser: PropTypes.number,
    tagInitial: PropTypes.string
  }),
  currentTag: ImmutablePropTypes.mapContains({}),
  isEditMode: PropTypes.bool
};

TagItem.defaultProps = {};

export default injectIntl(TagItem);



// WEBPACK FOOTER //
// ./src/script/components/tag/TagItem.js